var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import { forwardRef } from "react";

const SvgNote = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6531 4.07765L9.93325 0.351826C9.7094 0.127619 9.4047 0.00101566 9.08649 0H1.22807C0.550106 0.000671065 0.000676952 0.545323 0 1.21739V12.7826C0.000676952 13.4547 0.550106 13.9993 1.22807 14H12.7719C13.4499 13.9993 13.9993 13.4547 14 12.7826V4.91643C13.9991 4.60269 13.8746 4.30169 13.6531 4.07765ZM9.08772 1.23565L12.7253 4.86957H9.08772V1.23565ZM1.22807 12.7826V1.21739H7.85965V4.86957C7.86033 5.54163 8.40976 6.08629 9.08772 6.08696H12.7719L12.7725 12.7826H1.22807Z",
    fill: "black"
  })));
};

const ForwardRef = /*#__PURE__*/forwardRef(SvgNote);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/note.d6da00209c0a23195eb73f7e8ae8d724.svg";